/**
 * Browser-compatible wrappers around `crypto` methods.
 *
 * Some browsers (notably Opera with its built-in ad blocker / VPN / Aria AI)
 * and certain browser extensions monkey-patch the `crypto` object or its
 * methods. When these are called without the correct `this` binding, they
 * throw `TypeError: Illegal invocation`.
 *
 * These wrappers use `.call()` to preserve the correct `this` context.
 */
/**
 * Wrapper around `crypto.getRandomValues()` that preserves the correct
 * `this` binding via `.call(crypto)`, preventing "Illegal invocation"
 * errors from monkey-patched crypto objects.
 */
export function boundGetRandomValues(array) {
    return crypto.getRandomValues.call(crypto, array);
}
/**
 * Wrapper around `crypto.subtle.digest('SHA-256', data)` that preserves
 * the correct `this` binding via `.call(subtle)`, preventing "Illegal
 * invocation" errors from monkey-patched crypto objects.
 */
export async function boundSHA256Digest(data) {
    const subtle = crypto.subtle;
    return subtle.digest.call(subtle, 'SHA-256', data);
}
/**
 * Convenience: compute SHA-256 hex digest of a string using a bound
 * `crypto.subtle.digest` call.
 */
export async function boundSHA256HexDigest(input) {
    const data = new TextEncoder().encode(input);
    const hashBuffer = await boundSHA256Digest(data);
    const hashArray = new Uint8Array(hashBuffer);
    return Array.from(hashArray, (b) => b.toString(16).padStart(2, '0')).join('');
}
//# sourceMappingURL=safeCrypto.js.map